import { computed, defineComponent, ref } from 'vue';
import { useStore } from 'vuex';
import { useSweetAlert } from '@/composables/sweetalert';
import { ProjectAction, ProjectGetter } from '@/store/project/project.module';
import { Project, ProjectAttachment } from '@/store/project/project.model';
import BaseModalComponent from '@/components/baseModal/BaseModal.vue';

export default defineComponent({
  name: 'ProjectImageModalComponent',
  components: {
    BaseModalComponent,
  },
  props: {
    projectId: {
      type: Number,
    },
  },
  setup: (props) => {
    const store = useStore();
    const swal = useSweetAlert();
    const project = computed<Project | undefined>(() => store.getters[ProjectGetter.BY_ID](props.projectId));
    const images = computed<ProjectAttachment[]>(() => (project.value?.attachments) ? project.value?.attachments.filter(m => m.attachmentType.id === 2) : []);
    const isLoading = computed(() => store.getters[ProjectGetter.STATUS] === 'init' || store.getters[ProjectGetter.STATUS] === 'loading');
    const imageModal = ref<InstanceType<typeof BaseModalComponent>>();
    const fileDialog = ref<HTMLInputElement>();

    // show modal
    const show = () => {
      imageModal.value?.show();
    };

    // hide modal
    const hide = () => {
      imageModal.value?.hide();
    };

    // open file dialog
    const fileDialogOpen = () => {
      fileDialog.value?.click();
    };

    const fileDialogChange = () => {
      const files = fileDialog.value?.files as FileList;
      store.dispatch(ProjectAction.ADD_ATTACHMENTS, {
        fiscalYearId: project.value?.fiscalYear.id,
        projectId: project.value?.id,
        attachmentTypeId: 2,
        names: Array(files.length).fill('image'),
        attachments: files,
      });
    };

    const deleteImage = (id: number) => {
      swal.confirm('ลบข้อมูล!', 'คุณต้องการลบข้อมูลใช่หรือไม่?', 'ใช่ ลบเดี๋ยวนี้!', '#dc3545')
        .then((result) => {
          if (result.isConfirmed) {
            store.dispatch(ProjectAction.REMOVE_ATTACHMENTS, {
              fiscalYearId: project.value?.fiscalYear.id,
              projectId: project.value?.id,
              attachmentIds: [id],
            });
          }
        });
    };

    return {
      images,
      imageModal,
      fileDialog,
      isLoading,
      show,
      hide,
      fileDialogOpen,
      fileDialogChange,
      deleteImage,
    };
  }
});
